import url from 'url';
import { isEmpty, isNil } from 'lodash';

export const getUrlParams = (
    urlStr: string = window.location.href,
): {
    [x: any]: string | number | boolean;
} => {
    if (isEmpty(urlStr) || isNil(urlStr)) {
        return {};
    }

    const { query } = url.parse(urlStr, true);

    return query;
};

export const getUrlParamByKey = (key: string) => {
    if (isEmpty(key) || isNil(key)) {
        return null;
    }
    const query = getUrlParams();
    return query[key] || null;
};
